import React from 'react';

import axios from 'axios';

import {
    readCookie,
    eraseCookie,
} from '../helper';

class Authenticator extends React.Component {

    state = {
        user: {},
        auth: 'LOGGING_IN',
    };

    componentDidMount() {

        const cookie = readCookie('access_token');

        if (cookie) {

            this.setState({
                auth: 'LOGGING_IN',
            });

            window.strava = axios.create({
                baseURL: 'https://www.strava.com/api/v3/',
                headers: {'Authorization': 'Bearer ' + cookie},
            });

            axios.get(`/api/authenticate`, {
                headers: {
                    Authorization: cookie
                }
            })
                .then(response => {

                    this.setState({
                        user: response.data,
                        auth: 'LOGGED_IN',
                    });

                })
                .catch(error => {

                    this.setState({
                        auth: 'LOGGED_OUT',
                    });

                    eraseCookie('access_token');

                    console.warn(error.response.data);

                    window.alert(error.response.data.message);

                });

        } else {

            this.setState({
                auth: 'LOGGED_OUT',
            });

        }

    }

    render = () => {

        const {
            children,
            ...rest
        } = this.props;

        const {
            user,
            auth,
        } = this.state;

        return (
            auth === 'LOGGED_OUT' ?
                <a href={'/oauth/strava/redirect?redirect_url=/exchange'} className="btn btn-danger btn-strava mb-3">
                    <span>Mit Strava verbinden</span>&nbsp;
                </a> :
                auth === 'LOGGING_IN' ?
                    <div>Wait</div> :
                React.cloneElement(children, {
                    ...rest,
                    user,
                    auth,
                }))

    }

}

export default Authenticator
